{
  "loader": {
    "retry": {
      "message": "Laden fehlgeschlagen..."
    }
  },
  "notifications": {
    "invalidStore": "Ungültige Filiale. Zu Ihrer Standardfiliale gewechselt.",
    "invalidAisles": "Ungültige Gänge. Zu Standardfilterwert gewechselt.",
    "invalidDepartments": "Ungültige Abteilungen. Zu Standardfilterwert gewechselt.",
    "invalidTimeRange": "Ungültiger Zeitbereich. Zu Standard gewechselt.",
    "storeAccessChanged": "Filialen-Zugriff geändert. Bitte melden Sie sich erneut an."
  },
  "status": {
    "active": "aktiv",
    "inactive": "inaktiv",
    "deleted": "gelöscht"
  }
}
